export default function validateVendorName(value?: string) {
  let error;
  return error;
}
